module.exports = __webpack_public_path__ + "img/road.91c0fc97.png";